import { useState, useEffect } from "react";
import { FirestoreError } from "firebase/firestore";
import onSnapshotCollection from "./onSnapshotCollection";
import { Version } from "./types";
import {
  EntityGet,
  HookCollectionOpts,
  HookReturnCollection,
} from "../../../../types";

export type VersionUseCollectionHook<T> = (
  agentId: string,
  llmId: string,
  templatepartialId: string,
  opts?: HookCollectionOpts<T>
) => HookReturnCollection<T>;

const useCollection: VersionUseCollectionHook<EntityGet<Version>> = (
  agentId,
  llmId,
  templatepartialId,
  opts = {}
) => {
  const [data, setData] = useState<Array<EntityGet<Version>>>([]);
  const [error, setError] = useState<FirestoreError | null>(null);
  const [isLoading, setLoading] = useState(false);
  const { disabled = false, onSnap, track = [] } = opts;
  useEffect(() => {
    if (!disabled) {
      setLoading(true);
      const unsub = onSnapshotCollection(
        agentId,
        llmId,
        templatepartialId,
        opts || {},
        (docs) => {
          setData(docs);
          setLoading(false);
          if (typeof onSnap === "function") {
            onSnap(docs);
          }
        },
        (error) => {
          setLoading(false);
          setError(error);
        }
      );
      return () => {
        setLoading(false);
        unsub();
      };
    }
  }, [disabled, ...track]);
  return { data, error, isLoading };
};

export default useCollection;
